import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { signatureActions } from '../../../application/actions/signature';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiSignature = api(process.env.REACT_APP_SIGNATURE_API);

export function* fetchSignature() {
   /* istanbul ignore next */
  try {
    yield put(loadingActions.changeStatusLoadingFetchSignature({ isLoading: true }));
    /* istanbul ignore next */
    const { data, error } =  yield call(apiSignature.get, 'v1/solicitar');
   /* istanbul ignore next */
    if (data)
      yield all([
        put(signatureActions.fetchSignatureSuccess(data)),
        put(loadingActions.changeStatusLoadingFetchSignature({ isLoading: false })),
      ]);
     /* istanbul ignore next */
    else
     /* istanbul ignore next */
      yield all([
        put(signatureActions.fetchSignatureError(error)),
        put(loadingActions.changeStatusLoadingFetchSignature({ isLoading: false })),
      ]);
  } catch (err) {
     /* istanbul ignore next */
    console.error('signature saga error:', err);
    yield all([
      put(signatureActions.fetchSignatureError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingFetchSignature({ isLoading: false })),
    ]);
  }
}

export function* validateSignature(action) {
  try {
    yield put(loadingActions.changeStatusLoadingValidateSignature({ isLoading: true }));
     /* istanbul ignore next */
    const { data, error } =  yield call(apiSignature.post, 'v1/validar', action.payload);

    if (data)
      yield all([
        put(signatureActions.validateSignatureSuccess(data)),
        put(loadingActions.changeStatusLoadingValidateSignature({ isLoading: false })),
      ]);
    else
     /* istanbul ignore next */
      yield all([
        put(signatureActions.validateSignatureError(error)),
        put(loadingActions.changeStatusLoadingValidateSignature({ isLoading: false })),
      ]);
  } catch (err) {
     /* istanbul ignore next */
    yield all([
      put(signatureActions.validateSignatureError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingValidateSignature({ isLoading: false })),
    ]);
  }
}

export function* watchValidateSignature() {
  yield takeLatest(signatureActions.validateSignature.type, validateSignature);
}
export function* watchFetchSignature() {
  yield takeLatest(signatureActions.fetchSignature.type, fetchSignature);
}
 /* istanbul ignore next */
export default function* signatureSaga() {
  yield spawn(watchFetchSignature);
  yield spawn(watchValidateSignature);
}
